import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ColorDisabled, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { DiscountMessageBoxWidget } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { isDrawerOpen, setDrawer } from "../../../store/slices/global";
import { setSelectedWidget } from "../../../store/slices/widgets";
import { IdPopover } from "../../../utils/IdPopover";
import { MoreMenuWidget } from "../MoreMenuWidget";

import { IgDiscountMessageBox } from "./IgDiscountMessageBox";

interface MessageBoxWidgetPreviewProps {
  messageBoxWidget: DiscountMessageBoxWidget;
}
export const DiscountMessageBoxWidgetPreview = ({
  messageBoxWidget,
}: MessageBoxWidgetPreviewProps) => {
  const dispatch = useDispatch();
  const isWidgetDrawerOpen = useSelector(isDrawerOpen("widgetAction"));

  const toggleDrawer = () => {
    dispatch(setSelectedWidget(messageBoxWidget));
    dispatch(setDrawer({ drawer: "widgetAction", open: !isWidgetDrawerOpen }));
  };

  return (
    <Grid container item xs={12} md={12} lg={6} key={messageBoxWidget.id}>
      <IgPaper
        sx={{ paddingTop: "15px", paddingBottom: "15px", width: "100%" }}
      >
        <Grid item container direction={"column"} rowSpacing={2}>
          <Grid item container direction={"row"} alignItems={"center"}>
            <Grid item flex={1}>
              <IdPopover id={messageBoxWidget.id}>
                <IgTypography sx={{ fontSize: "14px", fontWeight: 600 }}>
                  {messageBoxWidget.name}
                </IgTypography>
              </IdPopover>
            </Grid>
            <Grid item>
              <MoreMenuWidget
                toggleDrawer={toggleDrawer}
                widgetType={"messageBoxPopup"}
              />
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction={"column"}
            rowSpacing={1}
            justifyContent={"center"}
          >
            <Grid
              item
              container
              direction={"column"}
              rowSpacing={1}
              alignItems={"center"}
            >
              <Grid
                item
                alignItems={"center"}
                textAlign={"center"}
                rowSpacing={2}
              >
                <Grid item>
                  <IgDiscountMessageBox
                    configType={"desktop"}
                    messageBoxWidget={messageBoxWidget}
                  />
                </Grid>
                <Grid item sx={{ marginTop: "10px" }}>
                  <IgTypography>Desktop</IgTypography>
                </Grid>
              </Grid>
              <Grid
                item
                sx={{
                  borderTop: `solid 1px ${ColorDisabled.light}`,
                  marginTop: "10px",
                  paddingTop: "15px !important",
                  textAlign: "center",
                }}
              >
                <Grid item>
                  <IgDiscountMessageBox
                    configType={"mobile"}
                    messageBoxWidget={messageBoxWidget}
                  />
                </Grid>
                <Grid item sx={{ marginTop: "10px" }}>
                  <IgTypography>Mobile</IgTypography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
